(function ($) {
  // cookies
  $.each($("#modal-cookies .collapse"), function (index, el) {
    $(el).on("hidden.bs.collapse", function (ev) {
      $(ev.target).prev("legend").removeClass("border-bottom");
    });
    $(el).on("shown.bs.collapse", function (ev) {
      $(ev.target).prev("legend").addClass("border-bottom");
    });
  });

  $("#modal-cookies legend input").on("change", function (e) {
    $(e.target).closest("fieldset").find("input[type=checkbox]").prop("checked", e.target.checked);
  });

  $(".collapse input[type=checkbox]").on("change", function (e) {
    var inputs = $(e.target).closest(".collapse").find("input[type=checkbox]");
    var res = {
      ok: 0,
      error: 0,
    };
    $.each(inputs, function (index, el) {
      el.checked ? res.ok++ : res.error++;
    });
    if (res.ok == inputs.length) {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", true);
    } else {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", false);
    }
  });

  $("#modal-cookies .btn-select-all").on("click", function (e) {
    $(e.target).closest(".modal").find("input[type=checkbox]").prop("checked", true);
    $(e.target).closest("form").submit();
    return false;
  });


  $("#modal-cookies .btn-just-essential").on("click", function (e) {
    $(e.target).closest(".modal").find("input[type=checkbox]:not([disabled])").prop("checked", false);
    $(e.target).closest("form").submit();
    return false;
  });


  $("#modal-cookies form").on("submit", function (e) {
    var valid = [
        "cookiePolicy",
        "matomo",
        // "adform",
        "google",
        // "facebook"
    ];
    var cookieData = {};
    var $form = $(e.target);
    var data = $form.serializeArray();

    $.each(valid, function (i, e) {
      var enable = data.findIndex(function (obj) {
        return obj.name === e;
      }) + 1 > 0;
      cookieData[e] = enable;
    });

    cookieData['cookiePolicy'] = true;

    $.each(cookieData, function (key, enabled) {
      switch (key) {
        case "cookiePolicy":
          break;

        case "matomo":
          if (typeof _paq !== "undefined") {
            if (enabled) {
              _paq.push(["setCookieConsentGiven", 9480]);
            } else {
              _paq.push([
                function () {
                  if (!this.isUserOptedOut()) {
                    _paq.push(["forgetCookieConsentGiven"]);
                  }
                },
              ]);
            }
          }
          break;

        // case "adform":
        //   if (enabled) {
        //     if (!Array.isArray(window._adftrack)) {
        //         initAdform();
        //       }
        //   }
        //   break;

        case "google":
          if (enabled) {
            if (typeof gtag === "undefined") {
                initGtag();
                initGMaps();
              }
          }
          break;

        case "facebook":
            if (enabled) {
              if (typeof fbq === "undefined") {
                initFBpx();
              }
          }
          break;
      }
    });
    BPM.COOKIESETTING = cookieData;
    createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    $("#modal-cookies").modal("hide");
    return false;
  });

  var checkCookie = function (name) {
    var nameCheck = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameCheck) == 0) return c.substring(nameCheck.length, c.length);
    }
    return null;
  };

  var createCookie = function (name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";

    document.cookie = name + "=" + value + expires + "; path=/; SameSite=Strict";
  };

  var eraseCookie = function (name) {
    createCookie(name, "", -1);
  };

  // var initAdform = function () {
  //   if (!ADFORM_ID || ADFORM_ID == 12345) {
  //     console.log('ADFORM_ID: ' + ADFORM_ID);
  //     return false;
  //   }
  //   window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : window._adftrack ? [window._adftrack] : [];
  //   window._adftrack.push({
  //     HttpHost: "track.adform.net",
  //     pm: ADFORM_ID,
  //     divider: encodeURIComponent("|"),
  //     pagename: encodeURIComponent(document.title),
  //   });
  //   (function () {
  //     var s = document.createElement("script");
  //     s.type = "text/javascript";
  //     s.async = true;
  //     s.src = "https://s2.adform.net/banners/scripts/st/trackpoint-async.js";
  //     var x = document.getElementsByTagName("script")[0];
  //     x.parentNode.insertBefore(s, x);
  //   })();
  // };


  var initGtag = function () {
    if (!GTAG_ID || GTAG_ID === 'XX-XXXXXX') {
      console.log('GTAG_ID: ' + GTAG_ID);
      return false;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GTAG_ID);
    (function () {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + GTAG_ID;
      document.head.append(s);
    })();
  };

  var initGMaps = function() {
    if (!$('.section-map').length) return;
    $('.section-map').each(function(index, el) {
      $(el).find('.alert-container')
        .prop('hidden', true);
      $(el).find('.ratio')
        .prop('hidden', false)
        .find('iframe')
        .attr('src', $(el).find('iframe').attr('data-src'));
    });
  };

  // var initFBpx = function() {
  //   if (!FB_PX || FB_PX === 'XX-XXXXXX') {
  //     console.log('FB_PX: ' + FB_PX);
  //     return false;
  //   }
  //   !function(f,b,e,v,n,t,s)
  //   {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  //   n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  //   if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  //   n.queue=[];t=b.createElement(e);t.async=!0;
  //   t.src=v;s=b.getElementsByTagName(e)[0];
  //   s.parentNode.insertBefore(t,s)}(window, document,'script',
  //   'https://connect.facebook.net/en_US/fbevents.js');
  //   fbq('init', FB_PX);
  //   fbq('track', 'PageView');
  // };

  BPM.COOKIESETTING = JSON.parse(decodeURIComponent(checkCookie("cookieSetting"))) || {
    cookiePolicy: false,
    matomo: false,
    adform: false,
    google: false,
    facebook: false,
  };

  BPM.CookiePolicy = function () {};

  BPM.CookiePolicy.cookieDuration = 30; // Tag/e
  BPM.CookiePolicy.cookieName = "cookieSetting";

  $(function () {
    // console.log(BPM.COOKIESETTING)
    if (!BPM.DNT && BPM.COOKIESETTING.cookiePolicy === false) {
        jQuery("#modal-cookies").modal("show");
    }
    // if (BPM.COOKIESETTING.cookiePolicy === true) {
    //     $("#customCookieModal").prop("checked", true);
    //     $("#cookieSet1").prop("checked", true);
    // }
    if (BPM.COOKIESETTING.matomo === true) {
      $("#customMatomo").prop("checked", true);
      $("#cookieSet3").prop("checked", true);
    }
    // if (BPM.COOKIESETTING.adform === true) {
    //   $("#cookieSet2").prop("checked", true);
      // $("#customAdform").prop("checked", true);
      // initAdform();
    // }
    // if (BPM.COOKIESETTING.facebook === true) {
    //   // $("#cookieSet2").prop("checked", true);
    //   $("#customFacebook").prop("checked", true);
    //   initFBpx();
    // }
    if (BPM.COOKIESETTING.google === true) {
      $("#customGoogle").prop("checked", true);
      initGtag();
      initGMaps();

      // if (/* BPM.COOKIESETTING.adform && */BPM.COOKIESETTING.facebook === true) {
        $("#cookieSet2").prop("checked", true);
      // }
    }
    if (!BPM.DNT) {
      createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    }
  });



  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }


  $(".contact_me").each(function (i, el) {
    var mail = $(el).attr("data-val") || false;
    if (!mail || mail.indexOf("§%§") === -1 || mail.indexOf("%§%") === -1) {
      $(el).attr("data-val", "");
      return;
    }
    mail = mail.replace(/\@/g, "o").replace(/%§%/g, "@").replace(/§%§/g, ".");
    var text = $(el).html().trim();

    var link = $("<a>", {
      href: "mailto:" + mail,
      rel: "nofollow",
      class: ($(el).attr('class') || "").replace('contact_me', ''),
      title: $(el).attr('title') || undefined,
    });
    link.html(!text ? mail : text);
    $(el).replaceWith(link);
  });


  $(".email_decode_me").each(function (i, el) {
    var mail = $(el).attr("data-val") || false;
    if (!mail || mail.indexOf("§%§") === -1 || mail.indexOf("%§%") === -1) {
      $(el).attr("data-val", "");
      return;
    }
    mail = mail.replace(/\@/g, "o").replace(/%§%/g, "@").replace(/§%§/g, ".");
    var text = $(el).html().trim();
    $(el).removeClass('email_decode_me');
    $(el).removeAttr('data-val');
    $(el).html(!text ? mail : (text + ' ' + mail));
  });


  $("html").removeClass("no-js").addClass("js");



  $(window).resize(
    debounce(function (e) {
      if ($('.bg-img').length) {
        window.setTimeout(function () {
          $('.bg-img').each(function(index, el) {
            resizeImage($(el));
          });
        }, 0);
      }
      if ($('.vert-img').length) {
        window.setTimeout(function () {
          $('.vert-img').each(function(index, el) {
            vertImage($(el));
          });
        }, 0);
      }

    }, 400)
  );


  function smoothScroll(e, direct) {
    var target;
    if (typeof direct === "undefined" || !direct) {
      target = this.hash;
      target = !target ? $(e.target).closest("a").attr("href") : target;
      target = !target ? window.location.hash : target;
    } else {
      target = e;
    }

    var $target = $(target).length ? $(target) : $("[name='" + window.location.hash.substr(1) + "']");

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - ($('#navbar-main').outerHeight(true) || 0),
        },
        400,
        "linear"
        // function() {
        //   window.location.hash = target;
        // }
      );
        // if (!!window.history) {
        //     history.pushState({}, window.title, '#' + $target.attr('id'));
        // }
    return false;
  }

    if (!!window.location.hash) {
        smoothScroll(window.location.hash, 1);
    }


  // scrollto hash
  $(".scrollTo").on("click", function (e) {
    e.preventDefault();
    smoothScroll(e);
    return false;
  });


    $(window).on('scroll', function() {
        if ( $(window).scrollTop() < 200 ) {
            $('.scroll-up').removeClass('show');
        } else {
            $('.scroll-up').addClass('show');
        }
    });

    var progressPath = document.querySelector('.scroll-up .icon-xxxl path');
    var pathLength = progressPath.getTotalLength();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
    progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
    var updateProgress = function () {
        var scroll = $(window).scrollTop();
        var height = $(document).height() - $(window).height();
        var progress = pathLength - (scroll * pathLength / height);
        progressPath.style.strokeDashoffset = progress;
    }
    updateProgress();
    $(window).scroll(updateProgress);


  // // scrollto navlinks
  // $(".nav-link", "#main-primary-menu").on("click", function (e) {
  //   var href = $(e.target).closest("a").attr("href");
  //   if (href.indexOf("#") + 1 < 1 || window.location.pathname !== "/") return;
  //   smoothScroll("#" + href.split("#").pop(), 1);
  //   $(e.target)
  //     .closest("ul")
  //     .find("li.active")
  //     .removeClass("current-menu-item active current-menu-item current_page_item");
  //   $(e.target).closest("ul").find("a").removeClass("current-menu-item current_page_item");
  //   $(e.target)
  //     .closest("li")
  //     .addClass("current-menu-item active")
  //     .find("a")
  //     .addClass("current-menu-item current_page_item");
  //   return false;
  // });


  // // navlink active link onload
  // $(window).on("load", function (e) {
  //   if (window.location.pathname !== "/") return;
  //   $("#main-primary-menu")
  //     .find("li.active")
  //     .removeClass("current-menu-item active current-menu-item current_page_item");
  //   $("#main-primary-menu").find("a").removeClass("current-menu-item current_page_item");
  //   $("li:first-of-type", "#main-primary-menu")
  //     .addClass("current-menu-item active")
  //     .find("a")
  //     .addClass("current-menu-item current_page_item");
  //   return false;
  // });



  // carousel img repair & touch
  function resizeImage($img) {
    $img.removeClass("resizeVertical");
    // console.log('resize', $img.attr('src'))
    if ($img.width() < $img.parent().width() && $img.width() > 0 && $img.height() >= $img.parent().height()) {
      $img.addClass("resizeVertical");
    }
  }
  function vertImage($img) {
    $img.removeClass("resizeVertical");
    // console.log('vert', $img.attr('src'))
    if ($img.height() < $img.parent().height() && $img.width() >= $img.parent().width() && $img.width() > 0) {
      $img.addClass("resizeVertical");
    }
  }

  $('img').on('load', function(e) {
    window.setTimeout(function() {
        if ($(e.target).hasClass('bg-img')) {
          resizeImage($(e.target));
        }
        if ($(e.target).hasClass('vert-img')) {
          vertImage($(e.target));
        }
    }, 0);
  });


  $(".carousel").on("touchstart", function (event) {
    if ($(event.target).closest(".carousel").hasClass("view")) return false;
    var xClick = event.originalEvent.touches[0].pageX;
    $(this).one("touchmove", function (event) {
      var xMove = event.originalEvent.touches[0].pageX;
      var btCarousel = bootstrap.Carousel.getOrCreateInstance(this);
      if (Math.floor(xClick - xMove) > 5) {
        btCarousel.next;
      } else if (Math.floor(xClick - xMove) < -5) {
        btCarousel.prev;
      }
    });
    $(".carousel").on("touchend", function () {
      $(this).off("touchmove");
    });
  });


  if (!!navigator.userLanguage || !!navigator.browserLanguage || !!navigator.systemLanguage) {
    $("body").addClass("ie11");
    // console.log("ie11");
  }


  //
  window.window.bpmShadowSvg = function(icon, classes) {
    return '<div class="svg-wrapper"><svg fill="currentColor"'
      + (!classes || classes.length ? '' : (' class="' + classes.join(' ') + '"'))
      + '><use href="#' + icon + '"/></svg></div>';
  };

  
  var $window = $(window);
  function reRenderMainNav() {
      var $oMainNav = $('#navbar-main').find('.container-fluid'),
          $oNavList = $('#bb4-primary-menu'),
          $oMoreLinks = $oNavList.find('.moreLinks');

      // Abbrechen, wenn Fensterbreite <= 767
      if ($window.width() <= 750) {
          $oMoreLinks.each(function () {
          $(this).addClass('nav-item')
              .find('.dropdown-item')
              .removeClass('dropdown-item')
              .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
          $oMoreLinks.remove();
          return;
      }

      if ($oMoreLinks.length) {
          $oMoreLinks.find('> ul > li').each(function () {
              $(this).addClass('nav-item')
                  .find('> .dropdown-item')
                  .removeClass('dropdown-item')
                  .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
      } else {
          var oMoreLinkElem = document.createElement('li'),
              oMoreLinkAElem = document.createElement('a'),
              oMoreLinkUlElem = document.createElement('ul');

          oMoreLinkElem.className = 'dropdown dropstart moreLinks menu-item nav-item';

          oMoreLinkAElem.className = 'dropdown-toggle nav-link menu-item d-inline-flex align-items-center';
          oMoreLinkAElem.innerHTML = '&nbsp;<div class="icon">' + window.bpmShadowSvg('svg-ellipsis-h') + '</div>&nbsp;'; // BPM.txt.more;
          oMoreLinkAElem.setAttribute('data-bs-toggle', 'dropdown');
          oMoreLinkAElem.setAttribute('href', '#');
          oMoreLinkAElem.setAttribute('rel', 'nofollow');

          oMoreLinkUlElem.className = 'dropdown-menu';
          oMoreLinkUlElem.setAttribute('role', 'menu');

          oMoreLinkElem.appendChild(oMoreLinkAElem);
          oMoreLinkElem.appendChild(oMoreLinkUlElem);

          $oNavList.append(oMoreLinkElem);
          $oMoreLinks = $(oMoreLinkElem);
      }

      var iMainNavWidth = $oMainNav.width()
              - $oMainNav.find('.navbar-brand').outerWidth(true)
              - ($oMainNav.find('.item1').outerWidth(true) || 0)
              - ($oMainNav.find('.item2').outerWidth(true) || 0)
              - ($oMainNav.find('.item3').outerWidth(true) || 0),
          $oNavItems = $oNavList.find('> li').not('.moreLinks'),
          iNavItemsWidth = 0,
          aMoreLinkElems = [];

      // console.log(iMainNavWidth)
      // console.log($oMainNav.find('.ms-auto.me-0').outerWidth(true));

      $oNavItems.each(function () {
          var $this = $( this );
          iNavItemsWidth += $this.outerWidth(true);
      });

      if (iNavItemsWidth > iMainNavWidth) {
          iMainNavWidth -= Math.ceil($oMoreLinks.outerWidth(true));
          iNavItemsWidth = 0;
          
          $oNavItems.each( function ()
              {
                  var $this = $( this );
                  iNavItemsWidth += $this.outerWidth(true);
              
                  if (Math.ceil(iNavItemsWidth) > iMainNavWidth) {
                      $this.removeClass('nav-item')
                          .find('> .nav-link')
                          .addClass('dropdown-item')
                          .removeClass('nav-link');
                      if ($this.hasClass('active')) {
                          $this.find('> a').addClass('active');
                      }
                      aMoreLinkElems.push( $this );
                  }
              }
          );
      }

      if (aMoreLinkElems.length) {
          $oMoreLinks.find('> ul').append(aMoreLinkElems);
      } else {
          $oMoreLinks.remove();
      }
  }

  $(function () {
      reRenderMainNav();
  });
  $(window).resize(function() {
      reRenderMainNav();
  });

  //////


  // // navbar/dropdown toggle
  //   function toggleDropdown(e) {
  //     var _d = $(e.target).closest(".dropdown"),
  //       _m = $(">.dropdown-menu", _d);
  //     // if ($(e.target).closest(".menu-large")) return;
  //     setTimeout(
  //       function () {
  //         var shouldOpen = e.type !== "click" && _d.is(":hover");
  //         _m.toggleClass("show", shouldOpen);
  //         _d.toggleClass("show", shouldOpen);
  //         $('>[data-toggle="dropdown"]', _d).attr("aria-expanded", shouldOpen);
  //       },
  //       e.type === "mouseleave" ? 50 : 0
  //     );
  //   }


  //   function toggleSubDropdown(e) {
  //     var _d = $(e.target).closest(".dropdown-submenu"),
  //       _m = $(">.dropdown-menu", _d);
  //     // if ($(e.target).closest(".menu-large")) return;
  //     setTimeout(
  //       function () {
  //         var shouldOpen = e.type !== "click" && _d.is(":hover");
  //         _m.toggleClass("show", shouldOpen);
  //         _d.toggleClass("show", shouldOpen);
  //         $('>[data-toggle="dropdown"]', _d).attr("aria-expanded", shouldOpen);
  //       },
  //       e.type === "mouseleave" ? 50 : 0
  //     );
  //   }


  //   $("body").on("mouseenter mouseleave", ".dropdown", toggleDropdown);
  //   // $("body").on("mouseenter mouseleave", ".dropdown-submenu", toggleSubDropdown);


  //   // main nav links clickable
  //   $('[data-bs-toggle="dropdown"]', "ul.navbar-nav").on("click", function(e) {
  //     if ($(e.target).closest(".menu-large").length) {
  //       return true;
  //     }
  //     e.preventDefault();
  //     e.stopPropagation();

  //     window.location.href = $(this).attr("href");
  //   });


  //////

    //// admin bar fix
    if ($('#wpadminbar').length) {
        $('html').attr('style', function(i,s) { return (s || '') + 'margin-top: 0 !important;' });
    }



    $(document).on('click', '.sec-accordion .title', function (e) {
        var $title = $(e.target).closest('.title');
        if (typeof _paq !== 'undefined') {
            _paq.push(['trackEvent', 'Accordion - ' + ($title.attr('aria-expanded') == 'true' ? 'open' : 'close'), $title.text()]);
        }
    });



    // contact
    $(".bpm-form-callback form, .bpm-form-contact form, .bpm-form-book form").on("submit", function(e) {
        e.preventDefault();
        var $form = $(e.target);

        var data = $form.serializeArray();
        // data.push({ name: "action", value: "bpmprojectformcontact" });
        data.push({ name: "nonce_in", value: bpm_project_data.nonce_in });

        $form.find(".btn[type=submit]").prop("disabled", true);
        $('.loading').prop('hidden', false);
        $('.is-invalid').removeClass('is-invalid');
        $form.find(".alert").attr('hidden', true).removeClass("alert-danger alert-success show");

        var post = {};
        data.map(function(x) {
            return (post[x.name] = x.value);
        });

        $.ajax({
            url: bpm_project_data.ajax_url,
            type: "POST",
            data: post,
            dataType: "json",
            success: function(json, textStatus, XMLHttpRequest) {
                var messageTxt = "";
                if (!json.success) {
                    for (var i = 0; i < json.errors.length; i++) {
                        for (var key in json.errors[i]) {
                            if (key === 'alert') {
                                messageTxt += json.errors[i][ key ] + "\n";
                            } else {
                                $("[name='" + key + "']")
                                    .addClass('is-invalid')
                                    .closest('.mb-3')
                                    .addClass('is-invalid')
                                    .find('.invalid-feedback')
                                    .text(json.errors[i][ key ]);
                            }
                        }
                    }
                    if (messageTxt.trim() == "") {
                        messageTxt = bpm_project_data.errorStandard;
                    }

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            data.action,
                            window.location.pathname.split('/').filter(Boolean).shift() || "",
                            0
                        ]);
                    }
                } else {
                    $form[0].reset();
                    $(".form-group-captcha", $form).addClass("d-none");
                    messageTxt = json.message || "";

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            data.action,
                            window.location.pathname.split('/').filter(Boolean).shift() || "",
                            1
                        ]);
                    }
                }

                if (messageTxt.trim() != "") {
                    $form
                        .find(".alert")
                        .attr('hidden', false)
                        .addClass("show alert-" + (!json.success ? "danger" : "success"))
                        .find(".text")
                        .text(messageTxt);
                }

                $form.find(".btn[type=submit]").prop("disabled", false);
            },
            error: function(MLHttpRequest, textStatus, errorThrown) {
                $form
                    .find(".alert")
                    .attr('hidden', false)
                    .addClass("alert-danger show")
                    .find(".text")
                    .text(
                        MLHttpRequest.status == 403
                        ? bpm_project_data.error403
                        : MLHttpRequest.statusText + " | Errorcode: " + MLHttpRequest.status
                    )

                $form.find(".btn[type=submit]").prop("disabled", false);
            },
            complete: function() {
                $('.loading').prop('hidden', true);
            }
        });

        return false;
    });


    var popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    var popoverList = [...popoverTriggerList].map(function(popoverTriggerEl) {
        new bootstrap.Popover(popoverTriggerEl)
    });


    // if ("AOS" in window) {
    //     AOS.init();
    // }


    // wow = new WOW({
    //     animateClass: 'animated',
    //     offset: 100
    // });
    // wow.init();

    //

})(jQuery);



(function($) {
    $.fn.countUp = function(options) {
        options = options || {};
        this
            .each(function () {
                var val = !! $(this).data('num') ? $(this).data('num') + "" : "";
                $(this).data('val', parseInt((val.replace(/[\.,]/,'') || '0'), 10));
                this.innerHTML = 0;
            })
            .on('inview', function(ev, isInView) {
                var i = +$(this).data('val'),
                    self = this;

                if (!isInView) {
                    self.innerHTML = 0;
                } else {
                    $({n: 0}).stop(true).animate({n: i},
                        {
                            duration: $.speed(
                                options.duration
                                || $(this).data('count-duration')
                                || 3500
                            ).duration,
                            step: function(now, fx) {
                                self.innerHTML = parseInt(now, 10).toLocaleString('de-DE');
                                self.setAttribute('data-up', parseInt(now, 10).toLocaleString('de-DE'));
                            }
                        }
                    );
                }
            });
    };

    // init
    $(function() {
        if ($('.sec-kpi .item-num').length) {
            $('.sec-kpi .item-num').each(function(index, el ) {
                $(el).countUp();
            });
            $('.sec-kpi .item-num2').each(function(index, el ) {
                $(el).countUp();
            });

            // // React InnerBlocks.Content nicht doubleable -> clone the old way
            // if ($('.sec-kpi-marque .box').length) {
            //     $('.sec-kpi-marque .box').each(function(i, el) {
            //         if (i % 1 === 0) {
            //             if ($(el).html().trim() === "") {
            //                 $(el).html($(el).prev().html());
            //             }
            //         }
            //     });
            // }
        }
    });

    // if ($('.sec-team .item').length) {
    //     $('.sec-team .item .progres').each(function(index, el ) {
    //         $(el).countUp();
    //     });
    // }



    // $(".skill-progress .progres").each(function (idx, el) {
    //     $(el).on('inview', function(ev, isInView) {
    //         if (!isInView) {
    //             $(this).css({
    //                 width: 0
    //             });
    //         } else {
    //             var myVal = $(this).attr('data-value');
    //             $(this).css({
    //                 width: myVal
    //             });
    //         }
    //     });
    // });



    var navScrollLinks = document.querySelectorAll("#navbar-main .scrollTo");
    var navCollapse = new bootstrap.Collapse(document.getElementById('bootstrap5-topnavbar'), {
      toggle: false,
    });

    for (var i = 0; i < navScrollLinks.length; i++) {
        console.log(navCollapse)
        navScrollLinks[ i ].addEventListener('click', function(e) {
          console.log(e.target)
          navCollapse.hide();
        });
    }


    // $(".breadcrumb").each(function (idx, el) {
    //     $(el).on('inview', function(ev, isInView) {
    //         if ($(this).hasClass('inview')) return;
    //         $(this).toggleClass('inview', isInView);
    //         if (isInView) {
    //             $(this).addClass('inview', isInView);
    //         }
    //     });
    // });



  $('.svg-vivus').each(function(index, el) {
    new Vivus(
      $(el).attr('id'),
      {
        duration: 60 * 5, // frames * sec
        // type: "oneByOne",
        pathTimingFunction: Vivus.EASE_OUT
      },
      function (obj) {
        obj.el.classList.add('finished');
      }
    );
  });



  // if ($('.carousel-shortcode')) {
  //   $('.carousel-shortcode').owlCarousel({
  //     loop: true,
  //     margin: 0,
  //     nav: false,
  //     mouseDrag: true,
  //     items: 1,
  //     dots: true,
  //     autoHeight: false,
  //     autoplay: true,
  //     smartSpeed: 500,
  //     autoplayHoverPause: true,
  //     center: false,
  //     navText: [
  //       "<div class='icon'>" + window.bpmShadowSvg('svg-arrow-left') + "</div>",
  //       "<div class='icon'>" + window.bpmShadowSvg('svg-arrow-right') + "</div>"
  //     ],
  //     responsive: {
  //       0: {
  //         items: 1,
  //         margin: 10,
  //       },
  //       576: {
  //         items: 1,
  //       },
  //       768: {
  //         items: 2,
  //         margin: 20,
  //       },
  //       992: {
  //         items: 2,
  //       },
  //       1200: {
  //         items: 3,
  //       }
  //     }
  //   });
  // }

})(jQuery);
